// KeyPointAlongSideIconMobileComponent.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const KEYPOINT_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/KeyPointVerticalVector.svg';

const renderFormattedText = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return (
        <strong key={i} style={{ fontWeight: 700 }}>
          {part.slice(2, -2)}
        </strong>
      );
    }

    return part;
  });

const KeyPointAlongSideIconMobileComponent = ({ data }) => {
  const { title, description, footer, steps } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        maxWidth: '100vw',
        backgroundColor: '#F3F6F6',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0 16px',
        boxSizing: 'border-box',
        gap: '32px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#162F3B',
          borderRadius: '34px',
          padding: '32px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          alignItems: 'center',
          alignSelf: 'stretch',
          boxSizing: 'border-box',
        }}
      >
        <ScrollFadeWrapper variant="text">
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.25rem',
              color: '#FFFFFF',
              textAlign: 'center',
              letterSpacing: '-0.03em',
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        {description && (
          <ScrollFadeWrapper variant="text" delay={0.2}>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1.25rem',
                lineHeight: '1.5rem',
                color: '#FFFFFF',
                textAlign: 'center',
                letterSpacing: '-0.03em',
                px: '16px',
                boxSizing: 'border-box',
                alignSelf: 'stretch',
                whiteSpace: 'pre-line',
              }}
            >
              {description}
            </Typography>
          </ScrollFadeWrapper>
        )}

        {footer && (
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              fontSize: '0.75rem',
              lineHeight: '1.25rem',
              color: '#FFFFFF',
              textAlign: 'center',
              letterSpacing: '-0.001em',
            }}
          >
            {footer}
          </Typography>
        )}
      </Box>

      {steps.map(({ icon, title, text }, index) => (
        <ScrollFadeWrapper key={index} delay={0.4 + index * 0.08}>
          <Box
            sx={{
              width: '100%',
              backgroundColor: '#FFFFFF',
              borderRadius: '34px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              boxShadow: '0px 3px 8px 0px #162F3B1F, 0px 1px 2px 0px #A2ACB133',
              boxSizing: 'border-box',
            }}
          >
            <Box sx={{ position: 'relative', width: '80px', height: '80px' }}>
              <Image
                width={80}
                height={80}
                src={KEYPOINT_VECTOR_URL}
                alt=""
                aria-hidden="true"
                sx={{ width: '100%', height: '100%' }}
              />
              <Image
                width={38}
                height={38}
                src={icon}
                alt=""
                aria-hidden="true"
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '38px',
                  height: '38px',
                  objectFit: 'contain',
                }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '1.25rem',
                lineHeight: '1.5rem',
                color: '#162F3B',
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '1.5rem',
                color: '#162F3B',
                letterSpacing: '-0.02em',
                whiteSpace: 'pre-line',
              }}
            >
              {renderFormattedText(text)}
            </Typography>
          </Box>
        </ScrollFadeWrapper>
      ))}
    </ScrollFadeSection>
  );
};

export default KeyPointAlongSideIconMobileComponent;
